const barcinoCookies = {
    init() {
        const config = document.getElementById('bc-cookie-config');
        const consentManager = window.tarteaucitron;
        if (!config || !consentManager) return;

        window.tarteaucitronForceLanguage = document.documentElement.lang === 'en' ? 'en' : 'fr';
        window.tarteaucitronForceExpire = 180;
        window.tarteaucitronExpireInDay = true;

        window.addEventListener('tac.root_available', () => {
            window.setTimeout(() => this._customizeInterface(config), 0);
            this._avoidFooterOverlap();
        }, {once: true});

        if (config.dataset.facebookPixelId) {
            consentManager.user.facebookpixelId = config.dataset.facebookPixelId;
            (consentManager.job = consentManager.job || []).push('facebookpixel');
        }

        if (config.dataset.googleTagId) {
            consentManager.user.gtagUa = config.dataset.googleTagId;
            consentManager.user.gtagCrossdomain = [];
            (consentManager.job = consentManager.job || []).push('gtag');
        } else {
            consentManager.services.barcino_analytics_preview = {
                key: 'barcino_analytics_preview',
                type: 'analytic',
                name: config.dataset.i18nAnalyticsTitle,
                uri: config.dataset.privacyUrl,
                needConsent: true,
                cookies: [],
                js() {},
                fallback() {},
            };
            (consentManager.job = consentManager.job || []).push('barcino_analytics_preview');
        }

        consentManager.init({
            privacyUrl: config.dataset.privacyUrl,
            readmoreLink: config.dataset.privacyUrl,
            hashtag: '#gestion-cookies',
            cookieName: 'barcino_consent',
            orientation: 'bottom',
            bodyPosition: 'top',
            groupServices: false,
            serviceDefaultState: 'wait',
            showAlertSmall: false,
            showTitleBanner: false,
            showDetailsOnClick: true,
            showIcon: false,
            cookieslist: true,
            adblocker: false,
            DenyAllCta: true,
            AcceptAllCta: true,
            highPrivacy: true,
            handleBrowserDNTRequest: false,
            removeCredit: true,
            moreInfoLink: true,
            useExternalCss: true,
            useExternalJs: false,
            mandatory: true,
            mandatoryCta: false,
            closePopup: false,
            googleConsentMode: true,
            softConsentMode: false,
            partnersList: false,
        });

        document.querySelectorAll('[data-cookie-settings]').forEach(button => {
            button.addEventListener('click', () => consentManager.userInterface.openPanel());
        });
    },

    _customizeInterface(config) {
        const alert = document.getElementById('tarteaucitronAlertBig');
        const message = document.getElementById('tarteaucitronDisclaimerAlert');
        if (alert && message && !alert.querySelector('.bc-cookie-banner-title')) {
            const title = document.createElement('span');
            title.className = 'bc-cookie-banner-title';
            title.textContent = config.dataset.i18nTitle;
            alert.insertBefore(title, message);
        }

        this._setText('#tarteaucitronDisclaimerAlert', config.dataset.i18nMessage);
        this._setText('#tarteaucitronPersonalize2', config.dataset.i18nAccept);
        this._setText('#tarteaucitronAllDenied2', config.dataset.i18nRefuse);
        this._setText('#tarteaucitronCloseAlert', config.dataset.i18nPersonalize);
        this._setText('#dialogTitle', config.dataset.i18nPanelTitle);
        this._setText('#tarteaucitronClosePanel', config.dataset.i18nClose);
        this._setText('#tarteaucitronServices_mandatory .tarteaucitronH3', config.dataset.i18nMandatoryMessage);
    },

    _setText(selector, text) {
        const element = document.querySelector(selector);
        if (element && text) element.textContent = text;
    },

    // Le bandeau initial est ancré en bas à gauche du viewport et peut
    // chevaucher les liens du footer (FAQ, gestion des cookies) une fois la
    // page scrollée jusqu'en bas. On le repousse au-dessus du footer tant
    // que celui-ci empiète sur sa zone.
    _avoidFooterOverlap() {
        const footer = document.querySelector('footer');
        if (!footer) return;

        let ticking = false;
        const update = () => {
            ticking = false;
            const footerTop = footer.getBoundingClientRect().top;
            const overlap = window.innerHeight - footerTop;
            document.documentElement.style.setProperty('--bc-cookie-banner-lift', overlap > 0 ? `${overlap}px` : '0px');
        };
        const onScrollOrResize = () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(update);
        };

        window.addEventListener('scroll', onScrollOrResize, {passive: true});
        window.addEventListener('resize', onScrollOrResize);
        update();
    },
};

export default barcinoCookies;
